module.exports = __webpack_public_path__ + "static/media/ex3.6dc6a5ab.jpg";